import React, { useState } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Chip, Collapse, Stack, Typography } from '@mui/material';

interface Props {
  label: string;
  values: Array<string>;
}

export default function CampaignScheduleValuePillCell({ label, values }: Props) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (values.length === 0) {
    return <Typography variant="body2">—</Typography>;
  }

  if (values.length === 1) {
    return <Typography variant="body2">{values[0]}</Typography>;
  }

  return (
    <Stack spacing={0.5}>
      <Chip
        clickable
        icon={isExpanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
        label={`${values.length} ${label}`}
        onClick={() => setIsExpanded((current) => !current)}
        size="small"
        sx={{ alignSelf: 'flex-start' }}
        variant="outlined"
      />
      <Collapse unmountOnExit in={isExpanded}>
        <Stack direction="row" flexWrap="wrap" gap={0.5}>
          {values.map((value) => (
            <Chip key={value} label={value} size="small" variant="outlined" />
          ))}
        </Stack>
      </Collapse>
    </Stack>
  );
}
